import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionPlanContentsItem from '../molecules/SubscriptionPlanContentsItem';

const UserInfoPlanContents = ({ tripTotalDays, schedule, outboundSessionFlight, inboundSessionFlight }) => {
  return (
    <React.Fragment>
      <div className="subscriptionPlanContentsContainer">
        {schedule && schedule.map((s, i) => {
          const dateDisplay = s.date.format('YYYY年M月D日');

          const outboundFlight = i === 0 ? outboundSessionFlight : null;
          const inboundFlight = i === tripTotalDays - 1 ? inboundSessionFlight : null;

          const index = i + 1;

          const { plan } = s;

          return (
            <SubscriptionPlanContentsItem
              key={index}
              index={i + 1}
              outboundFlight={outboundFlight}
              inboundFlight={inboundFlight}
              dateDisplay={dateDisplay}
              plan={plan}
              handleOutboundFlightChange={() => {}}
              handleInboundFlightChange={() => {}}
              handlePlanChange={() => {}}
              handlePlanDelete={() => {}}
              cantChangeFlight={true}
              cantChangeHotel={true}
              cantDeleteHotel={true}
              handleUpdateCheckin={() => {}}
              finalConfirm={true}
              hideCheckin={!(plan && plan.firstDay)}
              handleUpdateQuestion={() => {}}
              showQuestions={!!(plan && plan.firstDay)}
              hideMessage={!(plan && plan.firstDay)}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
};

UserInfoPlanContents.propTypes = {
  tripTotalDays: PropTypes.number.isRequired,
  schedule: PropTypes.array.isRequired,
  outboundSessionFlight: PropTypes.object.isRequired,
  inboundSessionFlight: PropTypes.object.isRequired,
};

export default UserInfoPlanContents;
